const createFromObject = (obj: Record<string, string | number | undefined | null>): string => {
    const params = new URLSearchParams();

    Object.entries(obj).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            params.append(key, String(value));
        }
    });

    const qs = params.toString();
    return qs ? `?${qs}` : '';
};

export default createFromObject;
